<div class="range-step">
  <section class="range-step__card">
    <h2 class="range-step__title">Scegli periodo</h2>

    <div class="range-step__values">
      <!-- Settimana -->
      <label class="range-step__value">
        <span>Settimana</span>
        <select
          class="range-step__input"
          [ngModel]="newBatchToUpload.batch_week"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateBatchWeek($event)"
        >
          <option *ngFor="let w of weeks" [ngValue]="w">
            {{ w }}
          </option>
        </select>
      </label>

      <!-- Anno -->
      <label class="range-step__value">
        <span>Anno</span>
        <select
          class="range-step__input"
          [ngModel]="newBatchToUpload.batch_year"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateBatchYear($event)"
        >
          <option *ngFor="let y of years" [ngValue]="y">
            {{ y }}
          </option>
        </select>
      </label>
    </div>
  </section>

  <section class="range-step__card">
    <h2 class="range-step__title">Scegli range</h2>

    <div class="range-step__values_2">
      <label class="range-step__value">
        <span>Quantità effettiva</span>
        <div class="range-step__input">
          {{ orderService.getBatchMaximumQty }}
        </div>
      </label>
      <label class="range-step__value">
        <span>Da..</span>
        <input
          type="text"
          inputmode="numeric"
          class="range-step__input"
          aria-label="Da"
          [ngModel]="newBatchToUpload.serial_from"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateSerialFrom($event)"
          [min]="getMinimum"
        />
      </label>

      <label class="range-step__value">
        <span>a..</span>
        <input
          type="text"
          inputmode="numeric"
          class="range-step__input"
          aria-label="A"
          [ngModel]="newBatchToUpload.serial_to"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="updateSerialTo($event)"
          [min]="getMinimum"
        />
      </label>
    </div>
  </section>
</div>
